import * as Scrivito from "scrivito";
import { sortBy } from "lodash";

// this function was added, because Scrivito SDK set orderedChildren() as its private method and it will be no more available as a Scrivito method
function getOrderedChildren(obj) {
  if (!obj) {
    return [];
  }
  const children = obj.children();
  const childOrder = obj.get("childOrder");

  if (!Array.isArray(childOrder)) {
    return children;
  }

  const childOrderIds = childOrder.map(
    (child) => child instanceof Scrivito.Obj && child.id()
  );
  return sortBy(children, (child) => {
    const childIndex = childOrderIds.indexOf(child.id());

    return childIndex === -1 ? childOrder.length : childIndex;
  });
}

export default getOrderedChildren;
